<template>
  <div
    class="w-full flex flex-col rounded-lg overflow-hidden shadow-lg border text-start cursor-default"
  >
    <div
      class="w-full aspect-[16/9] relative overflow-hidden skeleton-loading-bg"
    >
      <div
        class="absolute inset-0 darken-linear-background-b flex flex-col justify-end p-2 gap-1"
      >
        <div class="w-20 skeleton-loading-bg h-4 rounded" />
        <div class="flex gap-1">
          <span
            v-for="i in 3"
            :key="i"
            class="rounded aspect-square w-4 h-4 skeleton-loading-bg"
          />
        </div>
      </div>
    </div>
    <div class="bg-base-200 w-full h-24 flex flex-col p-2 gap-1">
      <span
        v-for="i in 3"
        :key="i"
        class="rounded w-full skeleton-loading-bg h-4"
      />
      <span class="rounded w-[25%] skeleton-loading-bg h-4" />
    </div>
    <div class="p-2 bg-base-200 w-full shrink-0">
      <div class="flex gap-1">
        <ChatSceneStateCardSkeleton class="w-[80%] shrink-0" />
      </div>
    </div>
  </div>
</template>
